export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10919.f55423b7.jpg";